import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { CSSProperties, HTMLAttributes } from 'react';

import * as Styled from './styles';

export type Props = HTMLAttributes<HTMLTableCellElement> & {
  'data-column-key'?: string;
};

const SortableHeaderCell = (props: Props) => {
  const columnKey = props['data-column-key'];

  if (!columnKey) {
    return <th {...props} />;
  }

  return <DraggableHeaderCell columnKey={columnKey} {...props} />;
};

type DraggableProps = Props & { columnKey: string };

const DraggableHeaderCell = ({ columnKey, ...props }: DraggableProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: columnKey });

  const style: CSSProperties = {
    ...props.style,
    transform: CSS.Translate.toString(transform),
    transition,
    cursor: 'grab',
    ...(isDragging ? { opacity: 0.5, zIndex: 1, position: 'relative' } : null)
  };

  return (
    <Styled.HeaderCell
      {...props}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    />
  );
};

export default SortableHeaderCell;
